var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-item"},[_vm._t("icon"),_c('p',{staticClass:"status-name"},[_vm._t("default")],2),_vm._t("status")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }